import { render } from "./OrderAthletesModal.vue?vue&type=template&id=3ae9e24b&scoped=true"
import script from "./OrderAthletesModal.vue?vue&type=script&lang=js"
export * from "./OrderAthletesModal.vue?vue&type=script&lang=js"

import "./OrderAthletesModal.vue?vue&type=style&index=0&id=3ae9e24b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ae9e24b"]])

export default __exports__